import type { GivingBase } from 'models';
import { Button, Col, Form, HandHeartLineIcon, Image, Row, Tag, Title, type TitleProperties } from 'ui';
import { images } from 'common/utils';
import { useGivingTypeOptions } from '../../hooks';

export type GiveImageWithTitle = {
  coverPhoto?: GivingBase['coverPhoto'];
  id: GivingBase['id'];
  name: GivingBase['name'];
  type: GivingBase['type'];
};

type P = {
  getPathToGivingDetail?: (id: string) => string;
  giving: GiveImageWithTitle;
  noStyle?: boolean;
  titleLevel: TitleProperties['level'];
};

const GivingImageWithTitle = ({ getPathToGivingDetail, giving, noStyle, titleLevel }: P) => {
  const { getTranslate } = useGivingTypeOptions();

  return (
    <Form.Item<GiveImageWithTitle> noStyle={noStyle}>
      <Row gutter={['xs', 0]}>
        <Col>
          <Image
            alt={giving.coverPhoto?.filename}
            borderRadius="small"
            height={72}
            objectFit="cover"
            src={giving.coverPhoto?.url ?? images.default.givingCoverPhoto}
            width={128}
          />
        </Col>
        <Col flex="auto">
          <Row justify="space-between">
            <Tag color="orange" icon={<HandHeartLineIcon />}>
              {getTranslate(giving.type)}
            </Tag>
            {getPathToGivingDetail ? (
              <Button navigate={{ to: getPathToGivingDetail(giving.id) }} type="link-primary">
                See detail
              </Button>
            ) : null}
          </Row>
          <Title level={titleLevel} marginBottom>
            {giving.name}
          </Title>
        </Col>
      </Row>
    </Form.Item>
  );
};

export default GivingImageWithTitle;
